module.exports = __webpack_public_path__ + "img/viber_image_2022-01-14_14-47-18-290.032a414d.png";